export const environment = {
  production: true,
  buildId: '3305131948121311',
  configFile: 'config.json',
};
